import accountCircleDark from "./account_circle_24px_dark.png";
import accountCircleLight from "./account_circle_24px_light.png";
import accountCircleGreen from "./account_circle_green.png";
type AccountCircleIconProps = {
  color?: "dark" | "light" | "green";
};

const ACCOUNT_CIRCLE_IMAGES: Record<"light" | "dark" | "green", string> = {
  light: accountCircleLight,
  dark: accountCircleDark,
  green: accountCircleGreen,
};

export const AccountCircleIcon = ({ color }: AccountCircleIconProps) => (
  <img
    height={20}
    src={ACCOUNT_CIRCLE_IMAGES[color || "light"]}
    alt="Account circle icon"
  />
);
